<template>
  <img
    src="@/assets/img/ai_assistant_ico.svg"
    :width="width"
    :height="height"
    style=""
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AIAssistant',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
  },
})
</script>
